// Qué pasa con el condado al elegir una dirección sugerida en la ficha del
// cliente (Josef Correia, Allinsure Group, 2026-11-05). Vive suelto, sin React,
// para poder probarlo.
/**
 * El condado que queda al elegir una sugerencia: el que trae la sugerencia; si
 * no trae, el que había solo si el ZIP no cambió (misma zona); si cambió, vacío.
 * `f` es el formulario ANTES de aplicar la sugerencia.
 */
export function condadoAlElegirDireccion(s, f) {
  const nuevo = String(s?.county || '').trim();
  if (nuevo) return nuevo;
  const zipNuevo = String(s?.zip || '').trim();
  const zipViejo = String(f?.addressZip || '').trim();
  return zipNuevo && zipNuevo !== zipViejo ? '' : (f?.county || '');
}
